export const types = {
  SET_IDLE_TIMER: "SET_IDLE_TIMER"
};

const minute = 60 * 1000;

const adminMinuteLimit = 99999;
const normalMinuteLimit = 5;

export const setIdleTimer = (isWaiting, admin = false) => ({
  type: types.SET_IDLE_TIMER,
  payload: {
    isWaiting,
    timeLimit: admin ? adminMinuteLimit * minute : normalMinuteLimit * minute
  }
});
